import React from 'react';
import styles from './CheckoutOfferPanel.styl';
import { RangeGroup, CheckboxContainer, MuiOfferPeriod } from '@bytebrand/fe-ui-core-autobahn/compat';
import { MdCheckbox as CheckboxMaterial } from '@bytebrand/fe-ui-core-autobahn/compat';
import { VehicleFormattedPrice } from '@bytebrand/fe-ui-core-autobahn/compat';
import { offers } from '@bytebrand/fe-ui-core-autobahn/constants';
const CheckoutOfferPanel = ({ t, onCheckoutModalClick, priceTabIndex, finalAdvice, additionalService, rangeGroupProps, offerPeriodProps, language, values, financingConfig }) => {
    const title = t(`common:offers.${priceTabIndex}.details`);
    const offerName = offers[priceTabIndex].name;
    const { common: { isStrikeShown }, [offerName]: { monthlyInstallment, oldMonthlyInstallment, financialInstitution } } = financingConfig;
    const modalProps = {
        title,
        content: [
            t(`modals:financing.details`, values),
            t(`modals:financing.info`, { financialInstitution })
        ],
        titleClassName: styles.titleCheckoutModal,
        modalName: 'DETAILS_MODAL'
    };
    return (React.createElement("div", { className: `${styles.offerBlockWrapper} ${priceTabIndex === 1 && styles.offerBlockLeasingWrapper}` },
        React.createElement("span", { className: styles.paymentTypeName }, t(`common:offers.${priceTabIndex}.name`)),
        !priceTabIndex && React.createElement("div", { className: styles.financingCheckboxWrapper },
            React.createElement(CheckboxMaterial, { ...finalAdvice, className: styles.finalCheckbox, formControlClassName: styles.finalAdvice })),
        React.createElement("div", { className: styles.rangeGroupWrapper },
            React.createElement(RangeGroup, { ...rangeGroupProps, className: styles.rangeGroup })),
        React.createElement("div", { className: `${styles.preparationCheckbox} ${language === 'en' && styles.englishFontSize}` },
            React.createElement(CheckboxContainer, { ...additionalService })),
        React.createElement("div", { className: styles.offerPeriodWrapper },
            React.createElement(MuiOfferPeriod, { ...offerPeriodProps })),
        React.createElement("div", { className: styles.priceDetailsBlock },
            React.createElement("div", { className: styles.priceWrapper },
                React.createElement("div", { className: styles.oldPriceWrapper },
                    isStrikeShown &&
                        React.createElement("div", { className: styles.monthlyRate },
                            React.createElement("span", null,
                                t('CheckoutPage:insteadOf'),
                                "\u00A0"),
                            React.createElement(VehicleFormattedPrice, { price: oldMonthlyInstallment, isOld: true, disableStyles: true, className: styles.oldFinancingPrice, toRound: false, numbersAfterDot: 0 })),
                    React.createElement("span", null, t('yourMonthlyRate'))),
                React.createElement("div", { className: styles.currentPriceWrapper },
                    React.createElement(VehicleFormattedPrice, { price: monthlyInstallment, isNew: isStrikeShown ? true : false, toRound: false, numbersAfterDot: 0, numberContainerClassName: styles.numberContainer, size: 'large', className: styles.unit }))),
            React.createElement("span", { className: styles.financingDetails, onClick: () => onCheckoutModalClick(modalProps) }, title))));
};
export default CheckoutOfferPanel;
